<template>
    <oss-dialog
        v-model="isVisible"
        title="Ecart de trésorerie"
        valid-title="Rapprochements bancaires"
        prefixDataCy="BankReconciliationDiscrepancyDialog"
        @valid="navigateToReconciliation()"
    >
        <p class="text-center" data-cy="BankReconciliationDiscrepancyDialog_ContentMessage">
            Il existe au moins un écart entre le solde de trésorerie et la comptabilité, veuillez accéder aux rapprochements bancaires pour plus de détails
        </p>
    </oss-dialog>
</template>

<script lang="ts">
import { Component, Model, toNative, Prop, Vue } from "vue-facing-decorator";

import { AuditCheckBankKey } from "@/types/auditCheck.types"

/**
 * Component for displaying a dialog when there is a discrepancy in the bank reconciliation.
 */
@Component({})
export class BankReconciliationDiscrepancyDialog extends Vue {
    /**
     * Indicates if the dialog is visible or not.
     */
    @Model() isVisible: boolean;

    /**
     * The accounting period id.
     */
    @Prop({ default: null }) readonly accountingPeriodId: string;

    /**
     * The company id.
     */
    @Prop({ default: null }) readonly companyId: string;

    /**
     * Navigates to the bank reconciliation page.
     */
    navigateToReconciliation(): void {
        this.$router.push({
            name: "bank-reconciliation",
            params: {
                companyId: this.companyId,
                accountingPeriodId: this.accountingPeriodId,
                acKey: AuditCheckBankKey.BankReconciliation,
            },
        });
    }
}

export default toNative(BankReconciliationDiscrepancyDialog);
</script>
